export const MODAL_STATUS = {
  success: "success",
  error: "error",
  disconnected: "disconnected",
  "disconnect-error": "disconnect-error",
  "change-plan-success": "change-plan-success",
  "cancel-subscription-success": "cancel-subscription-success",
  "reactivate-success": "reactivate-success",
};

